import React from 'react';
import { MetricUId } from '../../Metrics/constants';
import WidgetBodyWrapper from '../WidgetBodyWrapper';
import { getMetricDataFromArray } from '../../Metrics/utils';
import getChartConfig from './utils';
import SplineChart from '../../Reports/templates/SplineChart';
import MetricCard from '../MetricCard';
import { exportEventName } from '.';

const Body = (props) => {
  const { metrics } = props;
  const membershipRequestsReceivedTrend = getMetricDataFromArray(metrics, MetricUId.MEMBERSHIP_REQUESTS_RECEIVED_TREND);

  return (
    <WidgetBodyWrapper { ...props } additionalClassNames="max-height-500" >
      <div className='d-flex flex-column'>
        <MetricCard
          value={ membershipRequestsReceivedTrend.data.totalCount }
          title={ membershipRequestsReceivedTrend.name }
          className="mb-4"
        />
        <div className="align-self-stretch">
          <SplineChart
            chartOptions={ getChartConfig(membershipRequestsReceivedTrend.data) }
            configs={{ export: true, exportEventName }}
          />
        </div>
      </div>
    </WidgetBodyWrapper>
  );
};

export default Body;